import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
import { SubstitutionTypeEnum } from "@/modules/match/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'SubstitutionIncident',
  props: {
    rightSide: {
      type: Boolean
    },
    incident: null
  },
  setup(__props) {
    const props = __props;
    const iconMap = {
      [SubstitutionTypeEnum.IN]: IconEnum.ArrowLeft,
      [SubstitutionTypeEnum.OUT]: IconEnum.ArrowRight
    };
    const iconClassMap = {
      [SubstitutionTypeEnum.IN]: 'text-green-500',
      [SubstitutionTypeEnum.OUT]: 'text-red-600'
    };
    const icon = ref(iconMap[props.incident.substitutionType]);
    const iconClass = ref(iconClassMap[props.incident.substitutionType]);
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", {
        class: "flex items-center text-ellipsis whitespace-nowrap overflow-hidden",
        title: __props.incident.substitutionType === _unref(SubstitutionTypeEnum).IN ? _ctx.$t('in') : 'out'
      }, [__props.rightSide ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        icon: icon.value,
        size: "14px",
        class: _normalizeClass([iconClass.value, "mr-1"])
      }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.incident.player.shortName) + " ", 1), !__props.rightSide ? (_openBlock(), _createBlock(_component_Icon, {
        key: 1,
        icon: icon.value,
        size: "14px",
        class: _normalizeClass([iconClass.value, "ml-1"])
      }, null, 8, ["icon", "class"])) : _createCommentVNode("", true)], 8, _hoisted_1);
    };
  }
});